import script from "./BusinessNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessNotification.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessNotification.vue?vue&type=style&index=0&id=590c4cea&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590c4cea"]])

export default __exports__